<template>
    <div class="pagination-wrapper" v-if="nbPages > 1">
        <span class="first" @click.stop="handle('first')" :class="{disabled:isFirst}">
            <i class="fa fa-chevron-left"></i>
            <i class="fa fa-chevron-left"></i>
        </span>
        <span class="prev" @click.stop="handle('prev')" :class="{disabled:isFirst}">
            <i class="fa fa-chevron-left"></i>
        </span>
        <span class="page-infos"  @click.stop="togglePagesList">
            {{ $t('global.page') }} {{ currentPage }} {{ $t('global.pageSeparator') }} {{ nbPages }} <i class="fa fa-caret-up"></i>
        </span>
        <span class="next" @click.stop="handle('next')" :class="{disabled:isLast}">
            <i class="fa fa-chevron-right"></i>
        </span>
        <span class="last" @click.stop="handle('last')" :class="{disabled:isLast}">
            <i class="fa fa-chevron-right"></i>
            <i class="fa fa-chevron-right"></i>
        </span>
        <div class="pages-list" :class="{show: showPageList}" v-on-clickaway="closePagesList">
            <ul class="scroll">
                <li :class="{active:n == currentPage}" v-for="n in nbPages" @click.stop="go(n)">Page {{ n }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        name: 'pagination',
        props: [],
        mixins: [clickaway],
        computed: {
            isFirst: function(){
                return this.currentPage == 1;
            },
            isLast: function(){
                return this.currentPage == this.nbPages;
            }
        },
        data: () => ({
            nbPages: 1,
            currentPage: 1,
            showPageList: false,
            firstTime: true
        }),
        methods: {
            handle: function(type){
                var oldPage = this.currentPage;

                switch(type){
                    case 'first':
                        this.currentPage = 1;
                        break;
                    case 'prev':
                        if(this.currentPage > 1) {
                            this.currentPage--;
                        }
                        break;
                    case 'next':
                        if(this.currentPage < this.nbPages) {
                            this.currentPage++;
                        }
                        break;
                    case 'last':
                        this.currentPage = this.nbPages;
                        break;
                }

                if(oldPage != this.currentPage) {
                    this.go();

                }
            },
            go: function(page){

                if(page == null){
                    if(page != this.currentPage)
                    {
                        page = this.currentPage;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    this.currentPage = page;
                }


                this.closePagesList();
                this.$emit('change',page);

            },
            togglePagesList: function(){
                this.showPageList = !this.showPageList;
                if(this.showPageList && this.firstTime){
                    this.firstTime = false;
                }
            },
            closePagesList: function(){
                if (this.showPageList && !this.firstTime) {
                    this.showPageList = false;
                    this.firstTime = true;
                }
                else {
                    this.firstTime = false;
                }

            },
            update: function(obj){
                this.nbPages = obj.total_pages;
                this.currentPage = obj.current_page;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
